<template lang="pug">
    div(:style="'min-height:'+h")
        div.px-0.white.detail-head
            el-row.pl-5
                el-col(:span="8")
                    Breadcrumb
                el-col.pt-5.text-right(:span="15")
                    el-button( type="primary" size="mini" :loading="loading" @click="goto('/purchase/mon_account_statement_edit/1/1')") 申请月度对账单
                    el-button(type="primary" size="mini" :loading="loading" @click="exportData") 导出

            el-tabs.title(v-model="activeName" @tab-click="handleTabClick")
                el-tab-pane(:label="'待发布('+count1+')'" name="first")
                el-tab-pane(:label="'待我确认('+count2+')'" name="second")
                el-tab-pane(:label="'待供应商确认('+count3+')'" name="three")
                el-tab-pane(:label="'审批中('+count4+')'" name="four")
                el-tab-pane(:label="'被驳回('+count5+')'" name="five")
                el-tab-pane(:label="'全部('+count6+')'" name="six")
        div(style="height:110px")
        el-main.white.pa-3.ma-4
            el-row.py-3(v-if="!flag" type="flex" justify="center")
                el-col(:span="13")
                    el-row(type="flex" justify="center" :gutter="10")
                        el-col(:span="13")
                            el-input.w-100(v-model="list.key_name" placeholder="请输入对账月份/供应商/对账单号" clearable)
                        el-col(:span="11")
                            el-button(type="primary" @click="search(1)" :loading="loading") 查询
                            el-button(type="text" @click="flag = true" :loading="loading") 高级搜索
            div(v-else)
                el-row.py-3(type="flex" justify="center")
                    el-col(:span="22")
                        el-row(type="flex" justify="start" :gutter="10")
                            el-col(:span="6")
                                el-select.w-100(v-model="list.pk_org" :filter-method="sourcebuyorg" clearable filterable placeholder="采购组织")
                                    el-option(v-for="item in buyorg" :key="item.pk_org" :label="item.name" :value="item.pk_org")
                            el-col(:span="6")
                                el-select.w-100(v-model="list.sys_supplier_code" filterable remote placeholder="请搜索供应商" :remote-method="getSupplyList" :loading="loadingSupply" clearable)
                                    el-option(v-for="item in supply" :key="item.code" :label="item.name" :value="item.code")
                            el-col(:span="6")
                                el-input.w-100(v-model="list.code" placeholder="对账单号" clearable)
                            el-col(:span="6")
                                el-input.w-100(v-model="list.remark" placeholder="对账月份" clearable)
                            <!--el-col(:span="6")-->
                                <!--el-input.w-100(v-model="list.code_ct" placeholder="合同号" clearable)-->
                el-row.py-1(type="flex" justify="center")
                    el-col(:span="12")
                        el-row(type="flex" justify="center")
                            el-col(:span="10")
                                el-button(type="primary" @click="search(2)" :loading="loading") 查询
                                el-button(@click="clear") 清空
                                el-button(type="text" @click="flag = false" :loading="loading") 收起
            el-table(:data="data" v-loading="loading" size="mini")
                el-table-column(prop="remark" label="对账月份" width="100" key="remark")
                el-table-column(label="对账日期" width="180" key="begin_date")
                    template(slot-scope="scope")
                        span {{scope.row.begin_date}}-{{scope.row.end_date}}
                el-table-column(prop="code" label="对账单号" width="150"  key="code")
                el-table-column(prop="status" label="状态" width="80" key="status" v-if="activeName=='six'")
                    template(slot-scope="scope")
                        span {{getMBillStaDesc(scope.row.status)}}
                el-table-column(prop="org_name" label="采购组织" key="org_name" width="200"  show-overflow-tooltip)
                el-table-column(prop="supplier_name" label="供应商" key="supplier_name" width="200"  show-overflow-tooltip)
                el-table-column(prop="before_debt" label="期初欠款" width="100" key="before_debt")
                el-table-column(prop="before_invoice" label="期初欠票" width="100" key="before_invoice")
                el-table-column(prop="current_money" label="本期采购金额" width="100" key="current_money")
                <!--el-table-column(prop="current_money" label="本期采购数量" width="100" key="current_num")-->
                el-table-column(prop="current_pay" label="本期付款" width="100" key="current_pay")
                el-table-column(prop="after_debt" label="期末欠款" width="100" key="after_debt")
                el-table-column(prop="after_no_invoice" label="期末未到票" width="100" key="after_no_invoice")
                el-table-column(v-if="activeName=='four'" prop="source" label="对账来源" width="100" key="source")
                    template(slot-scope="scope")
                        span {{scope.row.source==1?'供应商':'建华'}}
                el-table-column(label="操作" :width="activeName=='first' || activeName=='second' || activeName=='three' || activeName=='four'?300:180" key="op")
                    template(slot-scope="scope")
                        el-button(v-if="activeName!='first'" size="mini" type="primary" plain @click="goto('/purchase/mon_account_statement_detail/'+scope.row.id+'/3')") 详情
                        el-button( v-if="activeName=='first'|| activeName=='five'" size="mini" type="primary" plain @click="goto('/purchase/mon_account_statement_edit/'+scope.row.id+'/2')") 发布
                        el-button(v-if="scope.row.approval_status!=0"  size="mini" type="primary" plain @click="getApprove('mBill',scope.row.approval_id)") 审批信息
                        el-button(v-if="scope.row.approval_status==0" v-show="activeName=='first'" size="mini" type="danger" plain :loading="loading" @click="handelDelete(scope.row)") 删除
                        el-button(v-if="activeName=='second'"  size="mini" type="primary" plain :loading="loading" @click="submitOA(scope.row)") 提交OA
                        <!--el-button(v-if="user.role == 3 ? true : ops.indexOf('all_close') > -1" v-show="activeName=='second' || activeName=='three' || activeName=='four'" size="mini" type="danger" plain :loading="loading" @click="close(scope.row,'1')") 关闭-->
            el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total,sizes, prev, pager, next, jumper" :total="count" background)
            el-dialog(title="审批信息" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="true" :close-on-press-escape="false")
                el-timeline(:reverse="true")
                    el-timeline-item(v-for="(item, index) in approve" :key="index" :timestamp="item.time")
                        div {{item.nodename+" : "+item.approver}}
                        div(v-if="item.opinion") 审批意见 : {{item.opinion}}
</template>
<script>
    export default {
        data() {
            return {
                flag: false,
                h: "",
                loading: false,
                activeName: "first",
                list: {
                    key_name: null,
                    page_num: 1,
                    page_size: 10,
                    status: 1,
                    state: 1,
                    buy_org: null,
                    code: null,
                },
                count: 0,
                count1: 0,
                count2: 0,
                count3: 0,
                count4: 0,
                count5: 0,
                count6: 0,
                list1: {
                    status: 1,
                    state: 1,
                    page_num: 1,
                    page_size: 10,
                },
                list2: {
                    status: 2,
                    page_num: 1,
                    page_size: 10,
                },
                list3: {
                    status: 3,
                    page_num: 1,
                    page_size: 10,
                },
                list4: {
                    status: 4,
                    page_num: 1,
                    page_size: 10,
                },
                list5: {
                    status: 5,
                    page_num: 1,
                    page_size: 10,
                },
                list6: {
                    status: null,
                    page_num: 1,
                    page_size: 10,
                },
                data: [],
                supply: [],
                dialogVisible: false,
                approve: [],
            };
        },
        methods: {
            async getApprove(type, id) {
                this.loading = true;
                let res = await this.$api.global.getApprove(type, 0, id);
                this.loading = false;
                this.dialogVisible = true;
                if (res) {
                    this.approve = res.data;
                } else {
                    this.approve = [];
                }
            },
            async getSupplyList(query) {
                if (!query) {
                    return false;
                }
                localStorage.setItem("PurchaseContract_query", query);
                this.loadingSupply = true;
                let res = await this.$api.supplier.getotherList({
                    key_name: query,
                    page_num: 1,
                    page_size: 100,
                    no_check: 1,
                    checkstatus: 3,
                });
                this.loadingSupply = false;
                if (res) {
                    this.supply = res.data;
                }
            },
            async submitOA(e) {
                this.loading = true;
                let res = await this.$api.mon_account_statement.submitOA(e.id);
                this.loading = false;
                if (res) {
                    this.$notify({
                        message: "操作成功",
                        type: "success",
                    });
                    this.getList();
                }
            },
            handelDelete(e) {
                this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(async () => {
                        this.loading = true;
                        let res = await this.$api.mon_account_statement.del(e.id);
                        this.loading = false;
                        if (res) {
                            this.$notify({
                                message: "操作成功",
                                type: "success",
                            });
                            this.getList();
                        }
                    })
                    .catch(() => {
                    });
            },
            /* search() {
              this.list.page_num = 1;
              this.$router.push({
                path: this.$route.path,
                hash: this.$route.hash,
                query: this.list,
              });
            }, */
            search(type) {
                if (type == 2) {
                    this.list.key_name = null;
                } else {
                    this.list.pk_org = null;
                    this.list.code = null;
                    this.list.sys_supplier_code = null;
                    this.list.remark = null;
                    this.list.code_ct = null;
                }
                this.$router.push({
                    path: this.$route.path,
                    hash: this.$route.hash,
                    query: this.list,
                });
            },
            clear() {
                this.list.pk_org = null;
                this.list.code = null;
                this.list.sys_supplier_code = null;
                this.list.remark = null;
                this.list.code_ct = null;
            },
            handleSizeChange(e) {
                this.list.page_size = e;
                this.$router.push({
                    path: this.$route.path,
                    hash: this.$route.hash,
                    query: this.list,
                });
            },
            handleCurrentChange(e) {
                this.list.page_num = e;
                this.$router.push({
                    path: this.$route.path,
                    hash: this.$route.hash,
                    query: this.list,
                });
            },
            handleTabClick(tab) {
                let data = this.list;
                if (tab.name == "first") {
                    data.page_size = this.list1.page_size;
                    data.page_num = this.list1.page_num;
                    data.status = this.list1.status;
                } else if (tab.name == "second") {
                    data.page_size = this.list2.page_size;
                    data.page_num = this.list2.page_num;
                    data.status = this.list2.status;
                } else if (tab.name == "three") {
                    data.page_size = this.list3.page_size;
                    data.page_num = this.list3.page_num;
                    data.status = this.list3.status;
                } else if (tab.name == "four") {
                    data.page_size = this.list4.page_size;
                    data.page_num = this.list4.page_num;
                    data.status = this.list4.status;
                } else if (tab.name == "five") {
                    data.page_size = this.list5.page_size;
                    data.page_num = this.list5.page_num;
                    data.status = this.list5.status;
                } else if (tab.name == "six") {
                    data.page_size = this.list6.page_size;
                    data.page_num = this.list6.page_num;
                    data.status = this.list6.status;
                }
                this.$router.push({
                    path: this.$route.path,
                    hash: "#" + tab.name,
                    query: data,
                });
            },
            async getList() {
                this.loading = true;
                let res = await this.$api.mon_account_statement.getList(this.list);
                this.loading = false;
                if (res) {
                    let data = res.data;
                    this.data = data.data;
                    this.count1 = data.count1;
                    this.count2 = data.count2;
                    this.count3 = data.count3;
                    this.count4 = data.count4;
                    this.count5 = data.count5;
                    this.count6 = data.count6;
                    switch (this.activeName) {
                        case "first":
                            this.count = this.count1;
                            break;
                        case "second":
                            this.count = this.count2;
                            break;
                        case "three":
                            this.count = this.count3;
                            break;
                        case "four":
                            this.count = this.count4;
                            break;
                        case "five":
                            this.count = this.count5;
                            break;
                        case "six":
                            this.count = this.count6;
                            break;
                        default:
                            break;
                    }
                }
            },
            async close(e, state) {
                this.$confirm("此操作将影响该行记录, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(async () => {
                        this.loading = true;
                        let data = {id: e.id, state: state};
                        let res = await this.$api.mon_account_statement.headClose(data);
                        this.loading = false;
                        if (res) {
                            this.$notify({
                                message: "操作成功",
                                type: "success",
                            });
                            this.getList();
                        }
                    })
                    .catch(() => {
                    });
            },
            initList() {
                let data = this.$route.query;
                if (JSON.stringify(data) != "{}") {
                    this.list = this.$utils.cloneDeep(data);
                    if (data.page_num) {
                        this.list.page_num = parseInt(data.page_num);
                    }
                    if (data.page_size) {
                        this.list.page_size =
                            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
                                ? parseInt(data.page_size)
                                : this.page_sizes[0];
                    }
                } else {
                    this.list.status = this.list1.status;
                }
                let status = this.list.status;
                switch (parseInt(status)) {
                    case 1:
                        this.activeName = "first";
                        break;
                    case 2:
                        this.activeName = "second";
                        break;
                    case 3:
                        this.activeName = "three";
                        break;
                    case 4:
                        this.activeName = "four";
                        break;
                    case 5:
                        this.activeName = "five";
                        break;
                    default:
                        this.list.status = null;
                        this.activeName = "six";
                        break;
                }
                switch (this.activeName) {
                    case "first":
                        this.list1.page_size = this.list.page_size;
                        this.list1.page_num = this.list.page_num;
                        break;
                    case "second":
                        this.list2.page_size = this.list.page_size;
                        this.list2.page_num = this.list.page_num;
                        break;
                    case "three":
                        this.list3.page_size = this.list.page_size;
                        this.list3.page_num = this.list.page_num;
                        break;
                    case "four":
                        this.list4.page_size = this.list.page_size;
                        this.list4.page_num = this.list.page_num;
                        break;
                    default:
                        break;
                }
                this.$router.push({
                    path: this.$route.path,
                    hash: "#" + this.activeName,
                    query: this.list,
                });
            },
            init() {
                this.activeName = this.$route.hash
                    ? this.$route.hash.split("#")[1]
                    : "first";
                this.initList();
                this.getList();
            },
            async exportData() {
                this.loading = true;
                await this.$api.mon_account_statement.getBlob(this.list);
                this.loading = false;
            },
        },
        mounted() {
            this.h = document.body.clientHeight - 61 + "px";
        },
        created() {
            if (this.$store.state.token && this.$store.state.purchase_org == false)
                this.getPurchaseOrg();
        },
        watch: {
            $route: {
                handler: "init",
                immediate: true,
            },
        },
    };
</script>